let audioCtx;

function getCtx() {
  if (!audioCtx) audioCtx = new (window.AudioContext || window.webkitAudioContext)();
  return audioCtx;
}

function tone(freq, start, duration, type = "sine", peak = 0.15) {
  const ctx = getCtx();
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, ctx.currentTime + start);
  gain.gain.linearRampToValueAtTime(peak, ctx.currentTime + start + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + duration);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(ctx.currentTime + start);
  osc.stop(ctx.currentTime + start + duration + 0.05);
}

export function playCorrectChime() {
  try {
    tone(880, 0, 0.18);
    tone(1318.5, 0.12, 0.25);
  } catch {
    // audio unsupported/blocked - fail silently
  }
}

export function playStreakCelebration() {
  try {
    [523.25, 659.25, 783.99, 1046.5].forEach((freq, i) => tone(freq, i * 0.09, 0.22, "triangle", 0.13));
  } catch {
    // audio unsupported/blocked - fail silently
  }
}

export function playClickSound() {
  try {
    tone(700, 0, 0.07, "sine", 0.09);
  } catch {
    // audio unsupported/blocked - fail silently
  }
}
